import { Calendar } from '@berlitz/icons'
import { Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

export const StyledCol = styled(Col)`
  margin: ${({ theme }) => `0 -${theme.space.lg}`};
  & > div {
    width: ${({ theme }) => `calc(100% + ${theme.space.xxxl})`};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    & > div {
      border-bottom: 1px solid ${({ theme }) => theme.palette.gray40};
    }
  }
`

export const StyledCalendar = styled(Calendar)`
  margin-right: ${({ theme }) => theme.space.xs};
`

export const StyledCalendarLoader = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: wait;
`

export const StyledCalendarLoaderBG = styled.div`
  background-color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: wait;
  opacity: 0.6;
`
